import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { useTQuery } from "../../utils/useTQuery";
import { useParams, useNavigate } from "react-router-dom";
import { useTMutation } from "../../utils/useTMutation";
import showToast from "../../components/Hot-Toast/showToast";
import { Button, Container, Box } from "@mui/material";

const ShiftRates = () => {
    const { ID } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState([]);

    // Fetch job role data
    const { data: jobRoleData, refetch, isLoading } = useTQuery(
        ["facilityRates", ID],
        `/job/facilityShiftRate?${new URLSearchParams({ ID }).toString()}`,
        "get",
        ID
    );

    // Mutation for saving data
    const mutation = useTMutation("/job/generateJobRoleShiftRate", "post", (data) => {
        if (data?.STATUS) {
            showToast("success", data.MESSAGE, 3000);
        } else {
            showToast("error", data.MESSAGE, 3000);
        }
    });

    // Effect to update data state when jobRoleData changes
    useEffect(() => {
        if (jobRoleData?.STATUS) {
            setData(jobRoleData.OUTPUT);
        }
    }, [jobRoleData]);

    // Handle input change
    const handleInputChange = (rowId, value) => {
        // return console.log(rowId, value)
        const updatedData = data.map((row) =>
            row.ID === rowId ? { ...row, payRatePerHour: value } : row
        );
        setData(updatedData);
    };

    // Save button functionality
    const handleSave = async () => {
        const dataToSave = data.map((row) => ({
            ID: row.ID,
            payRatePerHour: row.payRatePerHour,

        }));

        const response = await mutation.mutateAsync({ shiftRates: dataToSave, type: "update" });
        if (response?.STATUS) {
            refetch();
        }
    };

    // Generate default rates
    const handleGenerateRoleRate = async () => {
        const response = await mutation.mutateAsync({ ID, type: "generate" });
        if (response?.STATUS) {
            refetch();
        }
    };

    // Define table columns
    const columns = [
        {
            name: "Role Name",
            selector: (row) => row.jobRolesFacility?.ROLE_NAME,
            sortable: true,
        },
        {
            name: "Decimal Input",
            cell: (row) => (
                <input
                    type="number"
                    step="0.01"
                    value={row.payRatePerHour}
                    onChange={(e) => handleInputChange(row.ID, e.target.value)}
                    style={{ width: "100px" }}
                />
            ),
        },
    ];

    return (
        <Container>
            <Box mt={3} sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <Button variant="contained" className="custombuttons" onClick={() => navigate(-1)}>
                    Back
                </Button>
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleGenerateRoleRate}
                    disabled={data.length > 0}
                >
                    Generate Default Rate
                </Button>
            </Box>

            <DataTable
                title="Facility Shift Rate"
                columns={columns}
                data={data}
                pagination
                progressPending={isLoading}
            />

            {data.length > 0 ? (
                <Button
                    variant="contained"
                    color="success"
                    onClick={handleSave}
                    sx={{ marginTop: '20px' }}
                >
                    Update Rates
                </Button>
            ) : null}
        </Container>
    );
};

export default ShiftRates;
